import styled from "styled-components";

export const InvoiceOrganizationWrapper = styled.div`
  padding-top: 32px;
`;

export const Title = styled.div`
  color: var(--section-ebony-color, var(--ebony));
  margin-bottom: 16px;
  font-weight: 700;
  font-size: 15px;
  line-height: 24px;
`;

export const TableCell = styled.span`
  display: flex;
  flex-direction: column;
  max-width: 245px;
  min-width: 150px;
  align-items: start;
  font-size: 15px;
  flex-shrink: 0;
  font-weight: 400;
  line-height: 24px;
  color: var(--section-ebony-color, var(--ebony));

  small {
    font-size: 12px;
  }
`;

export const TableSmallCell = styled.span`
  display: flex;
  height: 15px;
  padding: 10px 0px;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  flex-shrink: 0;
  font-weight: 400;
  line-height: 24px;
  width: 124px;
  color: var(--section-ebony-color, var(--ebony));
`;
export const TableTotalCell = styled.span`
  justify-content: end;
  display: flex;
  padding-right: 40px;
`;

export const TD = styled.td`
  vertical-align: baseline;
`;

export const BigTD = styled(TD)`
  width: 248px;
  padding-left: 16px;
`;

export const SmallTD = styled(TD)`
  width: 245px;
`;
